import esES from './es-ES.js';

export default {
	...esES,
	app: {
		...esES.app,
		brand_zh: 'Ulucu',
		brand_en: 'ULUCU',
	},
	tabbar: {
		...esES.tabbar,
		monitor: 'Monitoreo',
		home: 'Inicio',
		store: 'Tienda',
		application: 'Aplicaciones',
		incidents: 'Incidencias',
		analytics: 'Analítica',
		operations: 'Operación',
		account: 'Cuenta',
		video: 'Video',
		reports: 'Reportes',
		workbench: 'Operación',
		messages: 'Mensajes',
		profile: 'Cuenta',
		reports_title: 'Analítica de clientes',
	},
	ops: {
		...esES.ops,
		title: 'Operación',
		subtitle: 'Rondas de tienda, inspección IA y flujos de dispositivos',
		available: 'Disponible',
		permission_required: 'Requiere activación',
		empty: 'Sin herramientas disponibles',
		view_status: 'Ver estado',
	},
	capability: {
		...esES.capability,
		available_short: 'Disponible para México',
		permission_required_short: 'Requiere activación del administrador',
		unknown_short: 'API pendiente de confirmar',
		region_unavailable_short: 'No disponible para México',
		permission_required_desc: 'Esta cuenta no tiene permiso para usar este módulo. Mensaje nativo: You do not have the right to this module.',
		unknown_desc: 'Esta función para APAC/México necesita verificación de API antes de mostrarse a usuarios.',
		region_unavailable_desc: 'Esta función pertenece al despliegue de China y no debe mostrarse en APAC/México.',
		back_to_operations: 'Volver a Operación',
	},
	root: {
		...esES.root,
		monitor: {
			...esES.root.monitor,
			subtitle: 'Video de tiendas, estado de dispositivos y vista múltiple',
			online_devices: 'Dispositivos en línea',
			offline_devices: 'Sin conexión',
			tools: 'Acciones de monitoreo',
			stores: 'Tiendas y canales',
			tool_store: 'Gestión de tiendas',
			tool_store_hint: 'Ver datos, grupos y estado operativo',
			tool_device: 'Estado de dispositivos',
			tool_device_hint: 'Revisar conexión, desconexión y canales',
			tool_multi_view: 'Vista múltiple',
			tool_multi_view_hint: 'Elige una tienda antes de ver hasta 4 canales',
			tool_multi_view_empty: 'No hay tiendas disponibles',
		},
		analytics: {
			...esES.root.analytics,
			subtitle: 'Tráfico, miembros, vehículos e indicadores de negocio',
			visible_modules: 'Módulos visibles',
			primary_period: 'Periodo principal',
			trend_period: 'Periodo de tendencia',
			tools: 'Herramientas de analítica',
		},
		incidents: {
			...esES.root.incidents,
			subtitle: 'Pendientes, alertas y mensajes de tus tiendas',
			pending: 'Pendientes',
			pending_hint: 'Por atender en operación',
			today: 'Incidencias de hoy',
			today_hint: 'Total del día',
			alerts: 'Alertas',
			alerts_hint: 'Riesgo, merma y anomalías',
			visible_types: 'Tipos de mensaje',
			unread: 'Sin leer',
			live: 'Al momento',
			tools: 'Herramientas de incidencias',
			workflow: 'Acciones principales',
			status_overview: 'Estado de incidencias',
			recent_messages: 'Mensajes recientes',
			inbox: 'Bandeja de incidencias',
			action_event: 'Atender incidencias',
			action_event_hint: 'Pendientes, apelaciones y revisión',
			action_alert: 'Revisar alertas',
			action_alert_hint: 'Ubica tiendas con riesgo o anomalías',
			action_message: 'Mensajes',
			action_message_hint: 'Avisos operativos y notificaciones',
			refresh: 'Actualizar resumen',
			updated_at: 'Actualizado {{time}}',
			not_updated: 'Sin actualizar',
			partial_data: 'Algunos datos no están disponibles',
			message_load_failed: 'No se pudieron cargar los mensajes',
			message_empty: 'No hay mensajes en esta categoría',
		},
		account: {
			...esES.root.account,
			subtitle: 'Organización, región, idioma y soporte',
			region: 'Región',
			recent_count: 'Vistos recientemente',
			support_count: 'Accesos de soporte',
			preferences: 'Región e idioma',
			profile_hint: 'Nombre, teléfono, correo y avatar',
			language_hint: 'Chino / Español México',
			activity: 'Actividad',
		},
	},
	incident_domain: {
		...esES.incident_domain,
		title: 'Mesa de incidencias',
		subtitle: 'Eventos, alertas y mensajes para operación en tienda',
		alert_note_desc: 'El detalle de alertas queda pendiente de confirmar con el catálogo de tipos de evento. Mientras tanto, usa el resumen y los mensajes para priorizar tiendas con riesgo.',
		event_message_hint: 'Tienes {{count}} mensajes de evento sin leer. Cambia a Mensajes para atenderlos.',
	},
	hotline: {
		...esES.hotline,
		local_value: 'Soporte México / APAC',
		local_desc: 'Para México no se muestra la línea 400 de China. Levanta una solicitud o contacta a tu ejecutivo local.',
		feedback_action: 'Levantar solicitud',
	},
	mtab: {
		...esES.mtab,
		video: {
			...esES.mtab.video,
			summary_one: '{{count}} tienda · Tasa de conexión: {{rate}}',
			summary: '{{count}} tiendas · Tasa de conexión: {{rate}}',
			offline_count_one: '{{n}} dispositivo sin conexión',
			offline_count: '{{n}} dispositivos sin conexión',
		},
	},
	scan: {
		...esES.scan,
		browser_supported: 'Escaneo disponible en este navegador',
		browser_unsupported: 'Este navegador no permite escanear',
		browser_supported_desc: 'En web se usa la capacidad del navegador; en iOS y Android se usará el escáner nativo.',
		browser_unsupported_desc: 'Usa la app móvil o un navegador compatible con cámara.',
		capacitor_plan: 'Para tiendas en México, el escaneo operativo debe ir en la app móvil con cámara nativa.',
		start_scan: 'Escanear',
	},
	rep: {
		...esES.rep,
		title: 'Reportes',
		dash: 'a',
		last_7d: 'últimos 7 días',
		today: 'hoy',
		unit: { ...esES.rep.unit, yuan: 'MXN' },
		cust: {
			...esES.rep.cust,
			title: 'Analítica de clientes',
			this_month: 'este mes',
			xsze: 'Ventas',
		},
		xdt: {
			...esES.rep.xdt,
			title: 'Operación de tienda',
		},
	},
};
